import Reveal from "./Reveal";
import { Truck, Cpu, Settings2, Leaf } from "lucide-react";

const services = [
  {
    icon: Truck,
    title: "Ready-Mix Concrete",
    desc: "Premium, high-quality concrete customized to meet the unique requirements of your project.",
  },
  {
    icon: Cpu,
    title: "Technology-Driven Production",
    desc: "AI and IoT integrated systems designed to monitor and optimize concrete quality while minimizing waste.",
  },
  {
    icon: Settings2,
    title: "Custom Mix Designs",
    desc: "Enchanting blends crafted for strength, resilience, and setting time, tailored for diverse endeavors.",
  },
  {
    icon: Leaf,
    title: "Sustainability Practices",
    desc: "Greywater reuse and environmentally sustainable practices in every batching plant operation.",
  },
];

const ServicesSection = () => (
  <section className="w-full bg-white py-12 md:py-16 lg:py-20 px-4 md:px-10 lg:px-16">
    <div className="max-w-7xl mx-auto">
      {/* Section Header */}
      <Reveal className="text-center mb-10 md:mb-12">
        <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
          [ OUR SERVICES ]
        </span>

        <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-semibold font-heading leading-relaxed mt-3">
          Empowering Industry Growth Through
          <br className="hidden sm:block" />
          Impactful and Innovative Solutions
        </h2>
      </Reveal>

      {/* Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {services.map((s, i) => {
          const Icon = s.icon;

          return (
            <Reveal key={s.title} delay={i * 80}>
              <div className="group h-full rounded-2xl p-6 border border-[#B3129E20] bg-white transition-all duration-300 hover:-translate-y-[3px] hover:border-[#B3129E60] hover:shadow-[0_10px_28px_rgba(179,18,158,0.12)]">
                {/* Icon */}
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4 bg-gradient-to-br from-[#B3129E] to-[#8F0F7D] text-white">
                  <Icon size={18} strokeWidth={2} />
                </div>

                {/* Title */}
                <h3 className="font-bold text-[#041122] mb-2 text-sm">
                  {s.title}
                </h3>

                {/* Description */}
                <p className="text-descriptionText text-xs leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default ServicesSection;
